import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full text-center" }
const _hoisted_2 = ["disabled"]

import { ref, watch } from 'vue';
import { useCheckout } from '@/storecontext/checkout/useCheckout';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { Form } from 'vee-validate';
import StoreEmployeeSelector from '@/storecontext/shared/employees/ui/StoreEmployeeSelector.vue';
import {
    CheckOutBankTransferPaymentRequest,
} from '@/storecontext/shared/api/server-apis';
import useStoreEmployees from '@/storecontext/shared/employees/useStoreEmployees';

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentBankTransfer',
  setup(__props) {

const { loaded, defaultEmployee, employees } = useStoreEmployees();

const labels = useBlockLabels();
const { gotoBankTransfer } = useCheckout();
const selectedSalesPersonId = ref<string>();

const handleSubmit = (orgRequest) => {
    const request: CheckOutBankTransferPaymentRequest = {
        soldByEmployee: employees.value.find(e => e?.id === orgRequest.soldByEmployee),
    };
    gotoBankTransfer(request);
};

watch(loaded, (value) => {
    if (value) {
        selectedSalesPersonId.value = defaultEmployee.value?.id;
    }
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_CIcon = _resolveComponent("CIcon")!

  return (_openBlock(), _createBlock(_unref(Form), {
    class: "max-w-380 text-left mx-auto mt-10",
    onSubmit: handleSubmit
  }, {
    default: _withCtx(({ isSubmitting }) => [
      _createVNode(StoreEmployeeSelector, {
        modelValue: selectedSalesPersonId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSalesPersonId).value = $event)),
        name: "soldByEmployee",
        label: _unref(labels).paymentSettingsSelectSalesPerson,
        class: "mb-x6"
      }, null, 8, ["modelValue", "label"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "submit",
          disabled: isSubmitting,
          class: "c-button c-button--primary flex flex-nowrap mx-auto items-center"
        }, [
          _createElementVNode("span", null, _toDisplayString(_unref(labels).bankTransferPaymentButtonConfirmAndSubmit), 1),
          _createVNode(_component_CIcon, {
            name: "icon-arrow-small",
            class: "w-8 h-8 mt-1 ml-6 xl:h-10 xl:ml-8 xl:-mt-1"
          })
        ], 8, _hoisted_2)
      ])
    ]),
    _: 1
  }))
}
}

})